/* Action types with TypeScript type declaration */
export const GET_MODEL_IS_PENDING = 'rpb2b-react/model/GET_MODEL_IS_PENDING';
export type GET_MODEL_IS_PENDING = typeof GET_MODEL_IS_PENDING;

export const SET_ID = 'rpb2b-react/model/SET_ID';
export type SET_ID = typeof SET_ID;

export const SET_MODEL_ID = 'rpb2b-react/model/SET_MODEL_ID';
export type SET_MODEL_ID = typeof SET_MODEL_ID;

export const SET_DIAGRAMS = 'rpb2b-react/model/SET_DIAGRAMS';
export type SET_DIAGRAMS = typeof SET_DIAGRAMS;

export const SET_MODEL_NUMBER = 'rpb2b-react/model/SET_MODEL_NUMBER';
export type SET_MODEL_NUMBER = typeof SET_MODEL_NUMBER;

export const SET_MODEL_NAME = 'rpb2b-react/model/SET_MODEL_NAME';
export type SET_MODEL_NAME = typeof SET_MODEL_NAME;

export const SET_MANUFACTURER = 'rpb2b-react/model/SET_MANUFACTURER';
export type SET_MANUFACTURER = typeof SET_MANUFACTURER;

export const SET_BRAND_NAME = 'rpb2b-react/model/SET_BRAND_NAME';
export type SET_BRAND_NAME = typeof SET_BRAND_NAME;

export const SET_APPLIANCE_TYPE = 'rpb2b-react/model/SET_APPLIANCE_TYPE';
export type SET_APPLIANCE_TYPE = typeof SET_APPLIANCE_TYPE;

export const SET_PRODUCTION_NUMBER = 'rpb2b-react/model/SET_PRODUCTION_NUMBER';
export type SET_PRODUCTION_NUMBER = typeof SET_PRODUCTION_NUMBER;

export const SET_TEXT_FILTER = 'rpb2b-react/model/SET_TEXT_FILTER';
export type SET_TEXT_FILTER = typeof SET_TEXT_FILTER;

export const SET_ACTIVE_DIAGRAM = 'rpb2b-react/model/SET_ACTIVE_DIAGRAM';
export type SET_ACTIVE_DIAGRAM = typeof SET_ACTIVE_DIAGRAM;

export const UPDATE_DIAGRAM_PRODUCT =
  'rpb2b-react/model/UPDATE_DIAGRAM_PRODUCT';
export type UPDATE_DIAGRAM_PRODUCT = typeof UPDATE_DIAGRAM_PRODUCT;

export const SET_ACTIVE_PART = 'rpb2b-react/model/SET_ACTIVE_PART';
export type SET_ACTIVE_PART = typeof SET_ACTIVE_PART;

export const SET_FEATURED_PRODUCTS = 'rpb2b-react/model/SET_FEATURED_PRODUCTS';
export type SET_FEATURED_PRODUCTS = typeof SET_FEATURED_PRODUCTS;

export const SET_COMMON_PARTS = 'rpb2b-react/model/SET_COMMON_PARTS';
export type SET_COMMON_PARTS = typeof SET_COMMON_PARTS;

export default {
  SET_ID,
  SET_MODEL_ID,
  SET_DIAGRAMS,
  SET_MODEL_NUMBER,
  SET_MODEL_NAME,
  SET_MANUFACTURER,
  SET_BRAND_NAME,
  SET_APPLIANCE_TYPE,
  SET_PRODUCTION_NUMBER,
  GET_MODEL_IS_PENDING,
  SET_TEXT_FILTER,
  SET_ACTIVE_DIAGRAM,
  UPDATE_DIAGRAM_PRODUCT,
  SET_ACTIVE_PART,
  SET_FEATURED_PRODUCTS,
  SET_COMMON_PARTS
};
